<template>
  <component :is="headingTag" class="decoration-sub-title">
    {{ text }}
  </component>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    headingLevel: {
      type: Number,
      required: false,
      default: 3
    }
  },
  computed: {
    headingTag() {
      return `h${this.headingLevel}`
    }
  }
}
</script>
<style lang="scss" scoped>
.decoration-sub-title {
  display: flex;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.6;
  box-sizing: border-box;
  border-bottom: 2px $primary solid;
  padding-bottom: 8px;
}
</style>
